import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import breederSchema from '@galo-monitor/forms/schemas/root/breeder.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { CultivarActions } from '@galo-monitor/stores/cultivar'
import Form from '@galo-monitor/web-components/Form'
import InputText from '@galo-monitor/web-components/InputText'

import { Container } from './theme'

const BreederForm = forwardRef((props, formRef) => {
  const { breeder, loading, setLoading, onSuccess, onError } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    data => {
      setLoading(true)
      dispatch(CultivarActions.saveBreeder(
        {
          ...breeder,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('breeder', { howMany: 1 }),
            action: toLower(t(isEmpty(breeder) ? 'created' : 'updated', { gender: 'female', howMany: 1 }))
          }))
          onSuccess()
        },
        onError
      ))
    },
    [breeder, dispatch, onError, onSuccess, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ breederSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <InputText
          name="name"
          label={ t('name') }
          defaultValue={ breeder?.name || '' }
          disabled={ loading }
          fullWidth
        />
      </Container>
    </Form>
  )
})

BreederForm.propTypes = {
  breeder: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

BreederForm.defaultProps = {
  breeder: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default BreederForm
